import DoneIcon from './component'

export default DoneIcon
